var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"four-container"},[_c('v-row',[_c('v-col',{attrs:{"xs":"12","align":"left","light":""}},[_c('p',{staticClass:"title"},[_vm._v("Page not found")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }